import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {Box, Grid, TextField} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState} from "react";
import {useAuthState} from "../../context/AuthContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ProfileService} from "../../pages/Profile/ProfileService";


const ChangePassword = ({openDialog, handleClose}) => {
    const token = useAuthState().token
    const snackbar = useSnackbarDispatcher()
    const loading = useLoadingDispatcher()
    const service = new ProfileService(token, snackbar, loading)
    // dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

    function changePassword() {
        if (newPassword === repeat)
            service.changeManagerProfilePassword(oldPassword, newPassword)
        else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "تکرار رمز عبور با رمز عبور مطابقت ندارد!"))
    }

    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    // dialog-end
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [repeat, setRepeat] = useState("")

    useEffect(() => {
        if (openDialog) {
            setNewPassword("")
            setOldPassword("")
            setRepeat("")
        }
    }, [openDialog])

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                تغییر رمز عبور
            </DialogTitle>
            <section className="modalContent">
                <Box className="d-flex flex-column w-100">
                    <Grid xs={12} className="w-100 p-2">
                        <TextField
                            className="w-100"
                            id="outlined-basic"
                            label="رمز عبور قبلی"
                            variant="outlined"
                            value={oldPassword}
                            onChange={e => {
                                setOldPassword(e.target.value)
                            }}/>
                    </Grid>
                    <Grid xs={12} className="w-100 p-2">
                        <TextField
                            className="w-100"
                            id="outlined-basic"
                            label="رمز عبور جدید"
                            variant="outlined"
                            value={newPassword}
                            onChange={event => setNewPassword(event.target.value)}/>
                    </Grid>
                    <Grid xs={12} className="w-100 p-2">
                        <TextField
                            className="w-100"
                            id="outlined-basic"
                            label="تکرار رمز عبور جدید"
                            variant="outlined"
                            value={repeat}
                            onChange={event => setRepeat(event.target.value)}/>
                    </Grid>
                </Box>
            </section>
            <section className="modalFooter">
                <button className="btn-confirm" onClick={changePassword}>
                    تغییر رمز عبور
                </button>
            </section>
        </Dialog>
    )
}
export default ChangePassword;